import { FormattedText } from 'components/typography';
import * as React from 'react';
import { BlockProps } from 'components/Blocks/index.types';
import DOMPurify from 'isomorphic-dompurify';
import PageSection from 'components/page/page-section';

function setListClassName(list: string) {
    return list.replaceAll('class="wp-block-footnotes"', 'class="footnotes" id="footnotes"');
}

export function FootNotes({ editorBlock }: BlockProps) {
    const html = DOMPurify.sanitize(setListClassName(editorBlock?.renderedHtml || ''));

    // @TODO: confirm that the issue with hydration is due to innher html - perhaps we need to remove external wrapper?
    return editorBlock?.renderedHtml ? (
        <PageSection hasLimitedWidth={true} inner={false} hasPadding={true}>
            <div className="footnotes-wrapper">
                <FormattedText>
                    <hr />
                    <br />
                    <div
                        className="footnotes-wrapper__inner"
                        dangerouslySetInnerHTML={{ __html: html }}
                    />
                </FormattedText>
            </div>
        </PageSection>
    ) : null;
}
